module.exports = __webpack_public_path__ + "img/seek.9c549774.jpg";